import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-page-content',
    template: require('./pageContent.directive.html')
})
export class PageContentComponent {

    @Input() showWebFooter: boolean;
    @Input() usePagePadding: boolean;
    @Input() pmcId: string;
    @Input() hoaId: string;
    @Input() propertyId: string;

    constructor() {
        this.showWebFooter = this.showWebFooter === false ? false : true; // default to 'true' if undefined or set incorrectly
        this.usePagePadding = this.usePagePadding === false ? false : true; // default to 'true' if undefined or set incorrectly
    }

}

